<template>
    <ul class="menu">
        <li class="menu__item"><router-link to="offers">Oferty</router-link></li>
        <li class="menu__item"><router-link to="about">O narzędziu</router-link></li>
    </ul>
</template>

<style lang="scss">
    .menu {
        list-style: none;
        padding: 0;
        margin: 0;

        &__item {
            display: inline-block;
            margin: 0 10px;
        }
    }
</style>

<script>
export default {};
</script>
